module.exports = __webpack_public_path__ + "img/18.9cabb6d5.jpeg";